/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
*/

// IP-NOTICE: MIXED
import { Component, OnDestroy } from '@angular/core';
import { BlockUiService } from './block-ui.service';
import { AuthService } from 'app/core/security/auth/auth.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';

@Component({
    //  selector: 'welcome',
    templateUrl: './block-template.component.html',
    styles: [
        `

      .message mat-icon {
        cursor: pointer;
      }
      .sub-message {
        font-size: 0.9em;
      }
    `,
    ],
    standalone: false
})
export class BlockTemplateComponent implements OnDestroy {
  message = '';
  showEscape = false;
  startSubscription: Subscription;
  stopSubscription: Subscription;
  timeoutId: any;
  constructor(private blockUiService: BlockUiService, private authService: AuthService, private router: Router) {
    console.log(`BlockTemplateComponent constructor`);

    // call initially and then subscribe to future blockerStarted events
    //this.initialiseForNewBlock()
    this.startSubscription = this.blockUiService.blockerStarted$.subscribe(() => {
      this.initialiseForNewBlock();
    }); 
    this.stopSubscription = this.blockUiService.blockerStopped$.subscribe(() => {
      console.log(`BlockTemplateComponent blockerStopped. Set escape false & clear timeout`);
      clearTimeout(this.timeoutId);
      this.showEscape = false;
    }); 
  }

  private initialiseForNewBlock() {
    console.log(`BlockTemplateComponent initialiseForNewBlock`);
    console.log(`BlockTemplateComponent initialiseForNewBlock. Set escape false`);
    this.showEscape = false;
    this.timeoutId = setTimeout(() => {
      console.log(`BlockTemplateComponent timeout. Set escape true`);
      this.showEscape = true;
    }, environment.uiBlockerTimeout);
  }

  ngOnDestroy() {
    this.startSubscription.unsubscribe();
    this.stopSubscription.unsubscribe();
  }

  get serviceContext(): string {
    return this.blockUiService.context;
  }

  get isSignedIn(): boolean {
    return this.authService.isLoggedIn();
  }

  escapeBlocker() {
    console.log(`BlockTemplateComponent escape blocker. Set escape false`);
    this.showEscape = false;
    this.blockUiService.stopBlockUI(this.serviceContext);
    window.location.reload();
  }
  loadWelcome() {
    console.log(`BlockTemplateComponent loadwelcome. Set escape false`);
    this.showEscape = false;
    this.blockUiService.stopBlockUI(this.serviceContext);
    this.router.navigateByUrl('/welcome');
  }
}
